import dropdownService from "../services/dropdownService";
import { useMutation } from "react-query";

const useGetAllGroup = (onData) => {
  return useMutation(dropdownService.userListDrowpdown, {
    onSuccess: (data) => onData(data),
  });
};

const dropdownQueries = {
  useGetAllGroup
};

export default dropdownQueries;
